export default [{
  name: 'products',
  path: '/productos/:name?',
  component: function component() {
    return import('pages/product/Index.vue');
  },
  meta: {
    title: 'Productos'
  }
}, {
  name: 'product-detail',
  path: '/productos/:brand/:id',
  component: function component() {
    return import('pages/product/Detail.vue');
  },
  meta: {
    title: 'Detalle del producto'
  }
}];